export const decodeIntegration = (integration) => {
    return {
        config: integration.config,
        created: integration.created,
        enabled: integration.enabled,
        id: integration.integration_id,
        integrationType: integration.integration_type,
        organisationId: integration.organisation_id
    };
};
export const encodeIntegration = (integration) => {
    return {
        config: integration.config,
        created: integration.created,
        enabled: integration.enabled,
        integration_id: integration.id,
        integration_type: integration.integrationType,
        organisation_id: integration.organisationId
    };
};
